export function getSiteUrl(props) {
    const currentSiteInfo = props.account.languages.find((l) => l.language === props.language);
    return (currentSiteInfo === null || currentSiteInfo === void 0 ? void 0 : currentSiteInfo.siteUrl) || props.account.siteUrl;
}
